(() => {
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const giftObserver = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      if (!isIntersecting) return;
      target.classList.add(target.matches('.image-with-text__heading') ? 'bebicia-gift-line' : 'bebicia-gift-enter');
      giftObserver.unobserve(target);
    });
  }, {threshold: .15});
  function init() {
    document.querySelectorAll('.bebicia-peek-image').forEach(image => {
      const media = image.parentElement;
      if (media.hasAttribute('data-bebicia-peek')) return;
      media.setAttribute('data-bebicia-peek', '');
      const ready = () => { if (image.naturalWidth) media.classList.add('is-peek-ready'); };
      image.addEventListener('load', ready, {once:true});
      ready();
      const card = media.closest('.card-wrapper, .ranking-card, .bebicia-featured-new-products__card') || media;
      card.addEventListener('pointerenter', () => { if (fine.matches) media.classList.add('is-peeking'); });
      card.addEventListener('pointerleave', () => { if (fine.matches) media.classList.remove('is-peeking'); });
      card.addEventListener('focusin', () => { if (fine.matches) media.classList.add('is-peeking'); });
      card.addEventListener('focusout', () => { if (fine.matches) media.classList.remove('is-peeking'); });
      let start = null, swiped = false;
      media.addEventListener('touchstart', e => { start = e.touches.length === 1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null; swiped=false; }, {passive:true});
      media.addEventListener('touchmove', e => {
        if (!start) return;
        const dx=e.touches[0].clientX-start.x, dy=e.touches[0].clientY-start.y;
        if (Math.abs(dx)>25 && Math.abs(dx)>Math.abs(dy)*1.4) {
          e.preventDefault(); e.stopPropagation(); swiped=true;
          media.classList.toggle('is-peeking', dx<0);
        }
      }, {passive:false});
      media.addEventListener('touchend', () => { start=null; }, {passive:true});
      media.addEventListener('touchcancel', () => { start=null; swiped=false; }, {passive:true});
      media.addEventListener('click', e => { if(swiped){e.preventDefault();e.stopPropagation();swiped=false;} }, true);
    });
    if (document.querySelector('[data-bebicia-gift-design]')) {
      document.querySelectorAll('main .image-with-text .media, main .image-with-text__heading').forEach(node => {
        if (observed.has(node)) return;
        observed.add(node);
        if (!reduce.matches) giftObserver.observe(node);
      });
    }
  }
  const timers = new WeakMap();
  document.addEventListener('bebicia:cart-added', e => {
    const button = e.detail?.button;
    if (!button) return;
    clearTimeout(timers.get(button));
    let mark=button.querySelector('.bebicia-cart-success-mark');
    if(!mark){mark=document.createElement('span');mark.className='bebicia-cart-success-mark';mark.textContent='✓';mark.setAttribute('aria-hidden','true');button.prepend(mark);}
    button.classList.add('bebicia-cart-confirmed');
    let status=document.getElementById('bebicia-cart-status');
    if(!status){status=document.createElement('span');status.id='bebicia-cart-status';status.className='visually-hidden';status.setAttribute('role','status');document.body.append(status);}
    status.textContent='カートに追加しました';
    setTimeout(()=>document.querySelectorAll('.cart-count-bubble').forEach(bubble=>{
      bubble.classList.remove('bebicia-cart-pulse');void bubble.offsetWidth;bubble.classList.add('bebicia-cart-pulse');
    }),150);
    timers.set(button,setTimeout(()=>{mark.remove();button.classList.remove('bebicia-cart-confirmed');status.textContent='';},1800));
  });
  init();
  let queued=false;
  new MutationObserver(records=>{
    if(queued || !records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1)))return;
    queued=true;requestAnimationFrame(()=>{queued=false;init();});
  }).observe(document.querySelector('main') || document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',init);
})();
